import { useEffect } from 'react';
import isIE from 'services/isIE';
import { colors, getButtonFocus } from 'styles/variables';

const { lPink } = colors;

const getObjectsTruthyValues = (obj: {}): {} => {
  const stripped = {};
  for (const property in obj) {
    if (obj[property]) {
      stripped[property] = obj[property];
    }
  }

  return stripped;
};

const updateLinkColors = (color = '#fff') => {
  return ['link', 'visited'].reduce((acc, curr) => {
    return {
      ...acc,
      [`:${curr}`]: {
        color: `${color} !important`,
      },
    };
  }, {});
};

const getFocusColorForCSSObject = (color: string) => {
  return !window.dev()
    ? getButtonFocus(color)
        .split(':')[1]
        .trim()
        .replace(';', '')
    : '';
};

interface IParsePropsAndTheme {
  props: {
    color: string;
    background: string;
    fontFamily: string;
    buttonShape: string;
    buttonShadow: boolean;
    buttonOutline: boolean;
    hoverColor: string;
    buttonHover?: string;
    focusColor: string;
  };
  theme: {};
}

const parseStylesFromPropsAndTheme = (props, theme) => {
  // console.log(theme.buttonShape);
  //
  // ensure the button returns to standard size if turned off in settings
  const useLargeButton =
    props.useLargeButton !== undefined
      ? props.useLargeButton
      : theme.useLargeButton;
  //

  return {
    background:
      (props.localBackgroundColor && props.background) ||
      theme.buttonBackgroundColor ||
      props.buttonBackground ||
      lPink,

    color:
      (props.localColor && props.color) ||
      theme.buttonTextColor ||
      props.buttonForeground ||
      '#fff',

    fontFamily: props.font || theme.fontFamily,
    buttonShape: props.buttonShape || theme.buttonShape,
    buttonOutline: props.localButtonOutline
      ? props.buttonOutline
      : theme.buttonOutline,
    buttonShadow: props.localButtonShadow
      ? props.buttonShadow
      : theme.buttonShadow,
    hoverColor: props.localButtonHover
      ? props.hoverColor || props.buttonHover
      : theme.hoverColor || theme.buttonHover,
    focusColor: getFocusColorForCSSObject(
      props.focusColor || props.background || theme.buttonBackgroundColor
    ),

    // useLargeButton: props.useLargeButton || theme.useLargeButton,
    useLargeButton,
    //
    borderRadius: props.localBorderRadius
      ? props.borderRadius
      : theme.buttonBorderRadius,
  } as any;
};

const updateButtonHeightForIE = (
  buttonRef: HTMLElement | null,
  buttonShape: string
) => {
  useEffect(() => {
    if (!(isIE() && buttonRef)) {
      return;
    }

    let goalHeight;

    if (buttonShape === 'circle') {
      goalHeight = buttonRef.offsetWidth;
    }

    const tick = setInterval(() => {
      if (!buttonRef) {
        return;
      }

      if (!goalHeight) {
        goalHeight = buttonRef.scrollHeight;
      }

      if (goalHeight !== 0 && buttonRef.style.height === `${goalHeight}px`) {
        clearInterval(tick);
      }

      buttonRef.style.height = `${goalHeight}px`;
    }, 1000 / 12);

    return () => {
      clearInterval(tick);
    };
  }, [buttonRef, buttonShape]);
};

export {
  getObjectsTruthyValues,
  updateLinkColors,
  getFocusColorForCSSObject,
  parseStylesFromPropsAndTheme,
  updateButtonHeightForIE,
};
